var _path, _g, _path2, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTensorflow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_62_1929)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_62_1929",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 0,
    width: 13,
    height: 29
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7029 7.02688L14.5402 0.10791V28.5405L19.4052 25.7293V17.7295L23.081 19.8379L23.0271 14.3784L19.4052 12.27V9.08078L26.7029 13.3509V7.02688Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_62_1929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.161743 0H29.9999V28.595H0.161743V0Z",
    fill: "url(#paint0_linear_62_1929)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_62_1929",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 13,
    height: 29
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.29712 7.02688L13.4593 0.10791V28.5405L8.59417 25.7293V9.08078L1.29712 13.3509V7.02688Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_62_1929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H29.836V28.595H0V0Z",
    fill: "url(#paint1_linear_62_1929)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_62_1929",
    x1: 0.161743,
    y1: 14.2969,
    x2: 29.9999,
    y2: 14.2969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_62_1929",
    x1: 0,
    y1: 14.2969,
    x2: 29.8376,
    y2: 14.2969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62_1929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 28.5944,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTensorflow);
export default __webpack_public_path__ + "static/media/Tensorflow.92136b109e0112026348b58c7029c5c5.svg";
export { ForwardRef as ReactComponent };